export { EloArrowUpIcon } from './arrow-up-icon'
